import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getItem } from '../utils/localStorage';

function OneTimeRoutes () {
  const userData = getItem('user');
  const location = useLocation();
  const loc: any = {...location};
  const isDeactivatedUser: any | null = (loc && loc.state && loc.state.isDeactivatedUser) || false;

  return (
      !userData || isDeactivatedUser ? <Outlet /> : <Navigate to="/dashboard" />
    );
}

export default OneTimeRoutes;
